import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { AnyHandler, DictHandler } from 'src/app/types/@types/sl-v-types';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { VocabularySettings } from 'src/app/components/att-vocab-view/att-vocab-view.component';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { CancellablePromise } from 'src/app/types/cancellable-promise';

export type TypeAheadExtantParams = {
	layerId: number,
	attribute: string,
	term?: string,
	limit: number
}

export type TypeAheadManagedParams = {
	id: number,
	attribute: string,
	term?: string,
	limit: number
}

@Injectable({
	providedIn: 'root'
})
export class ControlledVocabApiService {

	constructor(private wapi: SlWapiService, private messager: ModalMessagerService) {

	}
	GetVocab(layerId: number, valAtt: string, handler: AnyHandler, errorHandler: AnyHandler) {
		this.wapi.Post('layers/vocabulary/get', { layerId: (layerId), attribute: valAtt }).then((reply) => {
			if (reply.response.status === 'ok') {
				if (!!handler) {
					handler(reply.response);
				}
			}
			if (reply.status === 'error') {
				if (!!errorHandler) {
					errorHandler(reply.message);
				}
			}
		});
	}
	GetVocabById(id: number, handler: AnyHandler, errorHandler: AnyHandler) {
		this.wapi.Post('layers/vocabulary/get_vocab', { id: (id) }).then((reply) => {
			if (reply.response.status === 'ok') {
				if (!!handler) {
					handler(reply.response);
				}
			}
			if (reply.status === 'error') {
				if (!!errorHandler) {
					errorHandler(reply.message);
				}
			}
		});
	}
	GetUnique(layerId: number | string, valAtt: string, keyAtt?: string,
		handler?: AnyHandler, errorHandler?: AnyHandler) {
		const params: any = { layerId: (layerId), val: valAtt };
		if (!!keyAtt) {
			params.key = keyAtt;
		}

		this.wapi.Post('layers/vocabulary/list', params, true).then((reply) => {
			if (reply.response.status === 'ok') {
				if (!!handler) {
					handler(reply.response);
				} else {
					if (!!errorHandler) {
						errorHandler(reply.response);
					}
				}
			}
		});
	}
	GetUniqueUnlimited(layerId: number | string, valAtt: string, keyAtt?: string, handler?: AnyHandler, errorHandler?: AnyHandler) {
		const params = { force: 1, layerId: (layerId), val: valAtt };
		if (!!keyAtt) {
			params.val = valAtt;
		}
		this.wapi.Post('layers/vocabulary/list/', params, true).then((response) => {
			if (response.status === 'ok') {
				if (!!handler) {
					handler(response);
				} else {
					if (!!errorHandler) {
						errorHandler(response);
					}
				}
			}
		});

	}
	SaveVocab(settings: VocabularySettings, okHandler?: DictHandler, problemHandler?: AnyHandler) {
		const params = { layerId: settings.layerId, attribute: settings.attribute, vocab: JSON.stringify(settings.preferences) };
		this.wapi.Post('layers/vocabulary/upsert', params, true).then((reply) => {
			if (reply.status === 'ok') {
				if (!!okHandler) {
					okHandler(reply);
				}
			} else {
				if (!!problemHandler) {
					problemHandler(reply.message);
				}
			}
		}).catch((reason) => {
			if (!!problemHandler) {
				problemHandler(reason);
			}
		});
	}
	TypeAhead(params: TypeAheadExtantParams | TypeAheadManagedParams, term: string, context: 'managed' | 'extant' = 'managed') {
		params.term = term;
		let promise: CancellablePromise;

		switch (context) {
			case 'extant':
				promise = this.wapi.Post('layers/vocabulary/typeahead_extant', params);
				break;
			case 'managed':
				promise = this.wapi.Post('layers/vocabulary/typeahead_managed', params);
				break;
		}
		const obs = from(promise);
		return obs.pipe(
			map(reply => reply.response.vocab.results)
		);

	}

}
